<portal-return-to-link></portal-return-to-link>

<div class="page-heading" [class]="headingClass">
  <h1 class="page-heading__heading">
    <ng-content></ng-content>

    @if (hidePostfix === false) {
      @if (postfix == null) {
        @if (data$ | async; as data) {
          <span class="page-heading__postfix">
            <!-- Service Provider -->
            @if (data.showServiceProvider) {
              {{ 'pageHeading.ofServiceProvider' | portalTranslate: { name: data.name || '...' } }}
            }
            <!-- Enterprise -->
            @if (data.showEnterprise) {
              {{ 'pageHeading.ofEnterprise' | portalTranslate: { name: data.name || '...' } }}
            }
            <!-- End User -->
            @if (data.showEndUser) {
              {{ 'pageHeading.ofEndUser' | portalTranslate: { name: data.name || '...' } }}
            }
          </span>
        }
      } @else {
        <span class="page-heading__postfix">
          <ng-container [ngTemplateOutlet]="postfix"></ng-container>
        </span>
      }
    }
  </h1>

  <div class="page-heading__actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
